import '.er{font-size:1.125rem;}.ssr-plugin'
import '.e1{line-height:1.75rem;}.ssr-plugin'
import '.f8{text-decoration:none;}.ssr-plugin'
import '.ge{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="er e1"
    >
      {translations.privacySubtitle}{' '}
      <a className="f8 ge"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="f8 ge"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
